import { Card, CardContent } from '@skylabs-digital/backoffice-kit';
import { TimeSeriesChart } from '@skylabs-digital/backoffice-kit/charts';
import type { StorageSeries } from '../../schemas/storage.schema';
import { formatBytes } from '../apps/AppList';

const MB = 1024 * 1024;
const formatDay = (t: string | number) =>
  new Date(t).toLocaleDateString([], { month: 'short', day: 'numeric' });

/** Bytes en MB (recharts quiere números; un bigint serializado no sirve) y archivos aparte: un eje por gráfico. */
export function StorageChart({ series }: { series: StorageSeries | null }) {
  const points = (series?.points ?? []).map((p) => ({
    t: p.t,
    uploadedMb: Number(p.uploadedBytes) / MB,
    deletedMb: Number(p.deletedBytes) / MB,
    uploadedFiles: p.uploadedFiles,
  }));
  const busy = series === null;
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card>
        <CardContent className="pt-6">
          <TimeSeriesChart
            title="Bytes uploaded vs deleted per day"
            data={points}
            series={[
              { key: 'uploadedMb', label: 'Uploaded', type: 'bar' },
              { key: 'deletedMb', label: 'Deleted', type: 'bar', color: 'hsl(var(--destructive))' },
            ]}
            height={220}
            loading={busy}
            formatTime={formatDay}
            formatValue={(v) => formatBytes(v * MB)}
            emptyMessage="Nothing uploaded in this window"
          />
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <TimeSeriesChart
            title="Files uploaded per day"
            data={points}
            series={[{ key: 'uploadedFiles', label: 'Files', type: 'bar' }]}
            height={220}
            loading={busy}
            formatTime={formatDay}
            emptyMessage="Nothing uploaded in this window"
          />
        </CardContent>
      </Card>
    </div>
  );
}
